import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import Feather from 'assets/img/logos/feather-white.png';
import {
  MyProductsCard,
  Heading,
  ProductsSection,
  SectionTitle,
  ActiveProductsAlert,
  ProductLink
} from './styled';

const MyProducts = ({ activeProducts, inactiveProducts }) => {
  const productsCardVariants = {
    finish: {
      y: 0,
      opacity: 1,
      transition: {
        y: {
          type: 'spring',
          damping: 300,
          delay: 0.2
        },
        opacity: { delay: 0.2 }
      }
    },
    start: {
      y: 20,
      opacity: 0
    }
  };

  return (
    <MyProductsCard variants={productsCardVariants} animate="finish" initial="start">
      <Heading>My products</Heading>

      {isEmpty(activeProducts) && (
        <ActiveProductsAlert variant="warning" label="No active products">
          Please sign up by clicking one of the products below
        </ActiveProductsAlert>
      )}

      {!isEmpty(activeProducts) && (
        <ProductsSection>
          <SectionTitle>Signed up</SectionTitle>
          {activeProducts.map((product) => {
            return (
              <ProductLink
                key={product.name}
                href={product.url}
                variant={product.name}
                target={product.external ? '_self' : null}
              >
                <img src={Feather} alt="feather logo" width="24px" /> {product.label}
              </ProductLink>
            );
          })}
        </ProductsSection>
      )}

      {inactiveProducts.length > 0 && (
        <ProductsSection>
          <SectionTitle>Not signed up (yet)</SectionTitle>
          {inactiveProducts.map((product) => {
            return (
              <ProductLink
                key={product.name}
                href={product.registrationUrl}
                variant={product.name}
                target={product.external ? '_self' : null}
                inactive
              >
                <img src={Feather} alt="feather logo" width="24px" /> {product.label}
              </ProductLink>
            );
          })}
        </ProductsSection>
      )}
    </MyProductsCard>
  );
};

MyProducts.propTypes = {
  activeProducts: PropTypes.array,
  inactiveProducts: PropTypes.array
};

export default MyProducts;
